<script lang="ts" setup>
import Card9 from '@/components/Card/Card9.vue'
import { useGlobalStore, useUserStore } from '@/stores'
const userStore = useUserStore()
interface List {
  title: string
  link?: any
}

const memberUrl = computed(() => (userStore.isLoggedIn ? '/member' : import.meta.env.VITE_SSO_URL.replace("{:redirect_url}", import.meta.env.VITE_DOMAIN)))
const lists = ref([
  {
    title: '會員專屬購物禮遇',
    text: '下載APP即享450元折價券，禮遇陪你添購生活的亮點。',
    link: 'https://shop.hengstyle.com/',
    content: `
    下載APP即享450元折價券，完成註冊再得300元折價券與開卡禮50點，生日當月加碼500元生日禮，禮遇陪你選購家電廚房品。   
    `
  },
  {
    title: 'hengstyle 點數回饋',
    text: '在恆隆行指定直營通路、維修及深層清潔付費服務，消費同步累積回饋。',
    link: 'https://shop.hengstyle.com/',
    content: '依會員級別享0.5%–2.5%點數回饋。購物滿3,000元即可折抵，最高可抵結帳金額90%，維修與清潔服務無門檻可用，消費同步累積回饋。'
  },
  {
    title: '商品自動保固',
    text: '指定通路購物自動保固',
    link: 'https://shop.hengstyle.com/',
    content: '於恆隆行全通路購買商品，皆享自動登錄保固，無須填寫保固卡或留存紙本發票，用得安心也查得放心。'
  },
  {
    title: 'VIP 等級售後服務',
    text: '獨享優質售後服務',
    link: 'https://shop.hengstyle.com/',
    content: '除了產品維修外，恆隆行提供會員專人到府服務、深層清潔、快速維修及線上選品服務等 VIP 售後服務，黑卡享一年內一次免費深層清潔服務。'
  },
  {
    title: '會員限定活動',
    text: '專屬活動優先邀請',
    link: 'https://shop.hengstyle.com/',
    content: '恆隆行新品體驗會、會員課程與限定活動，金卡以上可優先報名，黑卡享專屬生日禮，走在生活潮流前端。'
  },
])
</script>

<template>
  <section class="section3List">
    <div class="section3List__inner">
      <ul class="lists">
        <li v-for="(item, index) in lists" :key="index">
          <Card9 :data="item" />
        </li>
        <li>
          <div class="lists__more">
            <div class="lists__more__title">更多會員禮遇敬請期待！</div>
            <nuxt-link class="lists__more__link" :to="memberUrl">
              <span class="lists__more__link__text">加入會員</span>
              <span class="lists__more__link__icon"><svg-icon name="icon-arrow-right" /></span>
            </nuxt-link>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section3List {
  @include grid;

  &__inner {
    grid-column: 3 / span 8;

    @include max-media(880) {
      grid-column: 1 / span 12;
    }
  }

  .lists {
    @include min-media(881) {
      column-count: 2;
      column-gap: toRem(24);
    }

    li {
      margin-bottom: toRem(24);
      break-inside: avoid;

      &:nth-child(odd) {
        background-color: $color-white-1;
      }

      &:nth-child(even) {
        background-color: $bg-1;

        :deep(.card__toggle__content) {
          background-color: $color-white-1;
        }
      }
    }

    &__more {
      display: flex;
      flex-direction: column;
      padding: toRem(32) toRem(40);
      background-color: $color-brand-3;
      color: $color-white-1;

      @include max-media(480) {
        padding: toRem(24);
      }

      &__title {
        margin-bottom: toRem(100);
        font-size: toRem(28);
        font-weight: 500;
        line-height: 1.3;

        @include max-media(480) {
          font-size: toRem(22);
        }
      }

      &__link {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        margin-left: auto;

        &__icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid $color-gray-line;
          border-radius: 50%;
          width: toRem(80);
          height: toRem(80);
          color: $color-brand-3;
          background-color: $color-white-1;

          @include max-media(480) {
            width: toRem(52);
            height: toRem(52);
          }

          svg {
            width: toRem(36);
            height: toRem(36);

            @include max-media(480) {
              width: toRem(24);
              height: toRem(24);
            }
          }
        }

        &__text {
          padding-right: toRem(16);
          font-size: toRem(28);
          font-weight: 500;
          line-height: 1.3;
          color: $color-white-1;

          @include max-media(480) {
            font-size: toRem(16);
          }
        }
      }
    }
  }
}
</style>
